import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import Slider from "../slick-wrapper";
import VideoPlayer from "../video-player";
import { NUMBER } from "../../../constants/app-constants";
import { SLIDER_SETTINGS, videoStyleWrapper } from "./constant";

const PostInspectionDiyVideoWrapper = ({
    heading,
    helperVideos = [],
    sliderSettings = SLIDER_SETTINGS
}) => {
    const [activeVideo, setActiveVideo] = useState(NUMBER.ZERO);
    const [videoReady, setVideoReady] = useState(helperVideos.reduce((acc, _, index) => {
        acc[index] = false;
        return acc;
    }, {}));
    const sliderRef = useRef();
    const playerRefs = useRef([]);
    if (playerRefs.current.length !== helperVideos.length) {
        playerRefs.current = Array(helperVideos.length)
            .fill()
            .map((_, i) => playerRefs.current[i] || React.createRef());
    }
    const {current = {}} = playerRefs.current[activeVideo] || {};

    const handleMediaEnd = (index) => {
        if (index > helperVideos.length - NUMBER.ONE) {
            sliderRef.current.slickGoTo(NUMBER.ZERO);
            setActiveVideo(NUMBER.ZERO);
        } else {
            setActiveVideo(index);
            sliderRef.current.slickNext();
        }
    };

    const handleVideoReady = (index) => {
        if (!videoReady[index]) {setVideoReady({...videoReady, [index]: true});}
    };

    const handleClick = (e) => {
        if (current) current.seekTo(NUMBER.ZERO, "seconds");
        const index = Math.ceil(e);
        handleMediaEnd(index);
    };

    return (
        <div styleName={`styles.videoWrapper`}>
            {helperVideos && helperVideos.length > NUMBER.ZERO && <div>
                {heading && <h2>{heading}</h2>}
                <Slider {...sliderSettings} ref={sliderRef} afterChange={handleClick}  >
                    {helperVideos.map(({videoUrl, image}, index) => (
                        <div key={index} styleName={"styles.videoSlideWrapper"} >
                            <img
                                styleName={`styles.imageWrapper ${videoReady[index] ? "styles.activeVideo" : "styles.hideVideo"} `}
                                src={image} alt="fallback"
                            />
                            <VideoPlayer
                                playerRef={playerRefs.current[index]}
                                autoPlay={false}
                                url={videoUrl}
                                onReady={() => handleVideoReady(index)}
                                width={"100%"}
                                height={"100%"}
                                playing={activeVideo === index}
                                controls={false}
                                volume={0}
                                onEnded={() => handleMediaEnd(index + NUMBER.ONE)}
                                fallback={<img src={image} alt="Fallback" />}
                                playsinline={true}
                                style={{...videoStyleWrapper}}
                            />
                        </div>
                    ))}
                </Slider>
            </div>}
        </div>
    );
};

PostInspectionDiyVideoWrapper.propTypes = {
    heading: PropTypes.string,
    helperVideos: PropTypes.array,
    sliderSettings: PropTypes.object
};

export default PostInspectionDiyVideoWrapper;
